import { LoggingVueApp } from '@schachermayer/sch-vuejs-commons/src/apps';
import { getModule } from 'vuex-module-decorators';
import UserInfoStoreModule from './store/modules/userInfo.module';

export abstract class ExtranetVueApp extends LoggingVueApp {

    /**
     * @deprecated This method should not be used because it does not set the locale for users that aren't logged in.
     * Instead, just load the userInfo yourself and set the locale there.
     */
    loadUserInfo() {
        const userInfoStore = getModule(UserInfoStoreModule, this.$store);
        userInfoStore.loadUserInfo().then(() => {
            this.$i18n.locale = userInfoStore.userInfo.locale;
        });
    }

}
